import { GET_PORTFOLIO, PORTFOLIO_DETAIL } from "./types";
import { host, getPortfolioUrl, portfolioDetail } from "./const";
import axios from "axios";
import network from "./network";

export const getPortfolio = (interval, exchangeId,tradeType) => (dispatch, getState) => {
  const params = {
    interval,
    exchange_id: exchangeId,
    trade_type: tradeType,
  }
  if(tradeType==""){
    delete params.trade_type
  }
   
  network
    .get(
      getPortfolioUrl,
      params,
      dispatch,
      getState
    )
    .then((res) => {
      const {
        equities,
        accumulative_trading_volume,
        trading_volume,
        realized_profits,
        portfolio_value,
        portfolio_changed,
      } = res.data;
      dispatch({
        type: GET_PORTFOLIO,
        payload: {
          equities,
          volumes: accumulative_trading_volume,
          trading_volume,
          realized_profits,
          portfolio_value,
          portfolio_changed,
          interval,
        },
      });
    });
};

export const getPortfolioDetail = (exchangeId) => (dispatch, getState) => {
  network
    .get(
      portfolioDetail,
      {
        exchange_id: exchangeId,
      },
      dispatch,
      getState
    )
    .then((res) => {
      //const { total, available, in_orders } = res.data;
     
      const { usd_m, coin_m, spot } = res.data;
      //const arr  = ...spot;
      dispatch({
        type: PORTFOLIO_DETAIL,
        payload: { usd_m, coin_m, spot },
      });
    });
};
